/**
 * Document Utilities
 * Utilities for managing document title and meta tags
 */

import { config } from '../config/environment';

/**
 * Set the document title
 * @param pageTitle - The page title to set
 */
export const setDocumentTitle = (pageTitle?: string) => {
  if (pageTitle) {
    document.title = `${pageTitle} | ${config.dashboard.appName}`;
  } else {
    document.title = config.dashboard.appName;
  }
};

/**
 * Set the document description meta tag
 * @param description - The description to set
 */
export const setDocumentDescription = (description: string) => {
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    document.head.appendChild(metaDescription);
  }
  metaDescription.setAttribute('content', description);
};

export default {
  setDocumentTitle,
  setDocumentDescription,
};
